'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
var _inherits = require('@babel/runtime/helpers/inherits');
var _createSuper = require('@babel/runtime/helpers/createSuper');
var typescriptClient = require('@fusionauth/typescript-client');
var core = require('@landr/core');
var AbstractAuthProvider = require('../AbstractAuthProvider.cjs');
var EventIds = require('../../../EventIds.cjs');
var storage = require('./storage.cjs');
var TransactionManager = require('./TransactionManager.cjs');
var utils = require('./utils.cjs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _createSuper__default = /*#__PURE__*/_interopDefaultLegacy(_createSuper);

function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var ACCESS_TOKEN_EXPIRE_WINDOW = 10 * 60 * 1000; // 10 minutes

var FusionAuthSPAAuthProvider = /*#__PURE__*/function (_AbstractAuthProvider) {
  _inherits__default["default"](FusionAuthSPAAuthProvider, _AbstractAuthProvider);
  var _super = _createSuper__default["default"](FusionAuthSPAAuthProvider);
  function FusionAuthSPAAuthProvider(_ref) {
    var _this;
    var domain = _ref.domain,
      clientId = _ref.clientId,
      platformProvider = _ref.platformProvider,
      environment = _ref.environment,
      log = _ref.log;
    _classCallCheck__default["default"](this, FusionAuthSPAAuthProvider);
    _this = _super.call(this);
    _this.domain = void 0;
    _this.clientId = void 0;
    _this.transactionManager = void 0;
    _this.platformProvider = void 0;
    _this.silentAuthRedirectUri = void 0;
    _this.log = void 0;
    _this.fusionAuthClient = null;
    _this.accessToken = null;
    _this.accessTokenExpiration = null;
    _this.silentlyCheckLoginPromise = null;
    _this.domain = domain;
    _this.clientId = clientId;
    _this.transactionManager = new TransactionManager.TransactionManager(storage.SessionStorage, _this.clientId, log);
    _this.platformProvider = platformProvider;
    _this.silentAuthRedirectUri = core.getGraphqlHttpUri(environment, {
      pathname: '/silent-auth-callback'
    });
    _this.log = log;
    return _this;
  }
  _createClass__default["default"](FusionAuthSPAAuthProvider, [{
    key: "init",
    value: function init() {
      this.fusionAuthClient = new typescriptClient.FusionAuthClient('', this.domain);
      return Promise.resolve();
    }
  }, {
    key: "handleError",
    value: function () {
      var _handleError = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(error) {
        var url;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getAuthorizeUrl({
                error: error
              });
            case 2:
              url = _context.sent;
              _context.next = 5;
              return this.silentLogoutAndRedirect(url);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleError(_x) {
        return _handleError.apply(this, arguments);
      }
      return handleError;
    }()
  }, {
    key: "redirectToLogin",
    value: function () {
      var _redirectToLogin = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(authState, queryParams) {
        var url;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getAuthorizeUrl({
                authState: authState,
                queryParams: queryParams
              });
            case 2:
              url = _context2.sent;
              if (!queryParams.forceLoginPrompt) {
                _context2.next = 8;
                break;
              }
              _context2.next = 6;
              return this.silentLogoutAndRedirect(url);
            case 6:
              _context2.next = 9;
              break;
            case 8:
              return _context2.abrupt("return", this.platformProvider.openUrl(url));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function redirectToLogin(_x2, _x3) {
        return _redirectToLogin.apply(this, arguments);
      }
      return redirectToLogin;
    }()
  }, {
    key: "logout",
    value: function logout(returnUrl) {
      var logoutUrl = this.getLogoutUrl({
        postLogoutRedirectUri: returnUrl
      });
      return this.platformProvider.openUrl(logoutUrl);
    }
  }, {
    key: "validateCodeAndState",
    value: function () {
      var _validateCodeAndState = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref2) {
        var state, code, transactionToUse, transaction, redirectUri, _yield$this$fusionAut, response, exception, authState;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref2.state, code = _ref2.code, transactionToUse = _ref2.transactionToUse;
              if (this.fusionAuthClient) {
                _context3.next = 3;
                break;
              }
              throw new Error('FusionAuth client not initialized');
            case 3:
              // Validate that we have a transaction in progress
              transaction = transactionToUse;
              if (transaction) {
                _context3.next = 8;
                break;
              }
              transaction = this.transactionManager.get();
              if (transaction) {
                _context3.next = 8;
                break;
              }
              throw new Error('No transaction');
            case 8:
              if (transaction.codeVerifier) {
                _context3.next = 10;
                break;
              }
              throw new Error('No code verifier');
            case 10:
              if (!(transaction.state && transaction.state !== state)) {
                _context3.next = 12;
                break;
              }
              throw new Error("Invalid state received comparing to transaction state");
            case 12:
              redirectUri = transaction.redirectUri || this.platformProvider.getRootUrl();
              _context3.next = 15;
              return this.fusionAuthClient.exchangeOAuthCodeForAccessTokenUsingPKCE(code, this.clientId, '', redirectUri, transaction.codeVerifier);
            case 15:
              _yield$this$fusionAut = _context3.sent;
              response = _yield$this$fusionAut.response;
              exception = _yield$this$fusionAut.exception;
              if (!(!response || exception || !response.access_token)) {
                _context3.next = 22;
                break;
              }
              if (!exception) {
                _context3.next = 21;
                break;
              }
              throw exception;
            case 21:
              throw new Error('Missing access token from response while exchanging code for access token');
            case 22:
              // Store tokens in memory only
              this.accessToken = response.access_token;
              // response.expires_in is the time in SECONDS until the token expires
              this.accessTokenExpiration = response.expires_in ? Date.now() + response.expires_in * 1000 : null;

              // When coming from error case, there is no app state
              authState = transaction.authState || {
                appState: {}
              };
              return _context3.abrupt("return", {
                authState: authState
              });
            case 26:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function validateCodeAndState(_x4) {
        return _validateCodeAndState.apply(this, arguments);
      }
      return validateCodeAndState;
    }()
  }, {
    key: "silentlyCheckLogin",
    value: function () {
      var _silentlyCheckLogin = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.silentlyCheckLoginPromise) {
                this.silentlyCheckLoginPromise = this.silentlyRefreshTokens()["finally"](function () {
                  _this2.silentlyCheckLoginPromise = null;
                });
              }
              return _context4.abrupt("return", this.silentlyCheckLoginPromise);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function silentlyCheckLogin() {
        return _silentlyCheckLogin.apply(this, arguments);
      }
      return silentlyCheckLogin;
    }()
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isLoggedIn;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.accessToken) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", Promise.reject(new Error('No access token')));
            case 2:
              _context5.next = 4;
              return this.silentlyCheckLogin();
            case 4:
              isLoggedIn = _context5.sent;
              if (isLoggedIn) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return", Promise.reject(new Error('Not logged in')));
            case 7:
              return _context5.abrupt("return", Promise.resolve(this.accessToken));
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getAccessToken() {
        return _getAccessToken.apply(this, arguments);
      }
      return getAccessToken;
    }()
  }, {
    key: "getAuthorizeUrl",
    value: function () {
      var _getAuthorizeUrl = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(_ref3) {
        var authState, redirectUri, error, queryParams, transactionToUse, transaction, codeChallengeBuffer, codeChallenge, scope, parameters, pagePath;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              authState = _ref3.authState, redirectUri = _ref3.redirectUri, error = _ref3.error, queryParams = _ref3.queryParams, transactionToUse = _ref3.transactionToUse;
              if (!redirectUri) {
                redirectUri = this.platformProvider.getRootUrl();
              }

              // Create transaction for later validation, and authState retrieval
              transaction = transactionToUse !== null && transactionToUse !== void 0 ? transactionToUse : this.transactionManager.create({
                authState: authState,
                redirectUri: redirectUri,
                shouldStore: true
              });
              _context6.next = 5;
              return utils.sha256(transaction.codeVerifier);
            case 5:
              codeChallengeBuffer = _context6.sent;
              codeChallenge = utils.bufferToBase64UrlEncoded(codeChallengeBuffer);
              scope = 'openid+offline_access'; // Redirect to authorization endpoint
              parameters = new URLSearchParams({
                client_id: this.clientId,
                response_type: 'code',
                code_challenge: codeChallenge,
                code_challenge_method: 'S256',
                redirect_uri: redirectUri,
                scope: scope,
                state: transaction.state
              });
              if (error) {
                parameters.append('error', error);
              }
              if (queryParams && queryParams.locale) {
                parameters.append('locale', queryParams.locale);
              }
              pagePath = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.isSignup) ? 'register' : 'authorize';
              return _context6.abrupt("return", "".concat(this.domain, "/oauth2/").concat(pagePath, "?").concat(parameters.toString()));
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getAuthorizeUrl(_x5) {
        return _getAuthorizeUrl.apply(this, arguments);
      }
      return getAuthorizeUrl;
    }()
  }, {
    key: "getLogoutUrl",
    value: function getLogoutUrl(_ref4) {
      var postLogoutRedirectUri = _ref4.postLogoutRedirectUri;
      var parameters = new URLSearchParams({
        client_id: this.clientId
      });
      if (postLogoutRedirectUri) {
        parameters.append('post_logout_redirect_uri', postLogoutRedirectUri);
      }
      return "".concat(this.domain, "/oauth2/logout?").concat(parameters.toString());
    }
  }, {
    key: "silentLogoutAndRedirect",
    value: function () {
      var _silentLogoutAndRedirect = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(loginUrl) {
        var logoutUrl, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.log.info('Silent logout', EventIds.AuthEventIds.SilentLogoutInvoked);
              logoutUrl = this.getLogoutUrl({});
              _context7.next = 4;
              return fetch(logoutUrl, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'include'
              });
            case 4:
              response = _context7.sent;
              if (!(response.status !== 200)) {
                _context7.next = 7;
                break;
              }
              return _context7.abrupt("return", this.logout(loginUrl));
            case 7:
              return _context7.abrupt("return", this.platformProvider.openUrl(loginUrl));
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function silentLogoutAndRedirect(_x6) {
        return _silentLogoutAndRedirect.apply(this, arguments);
      }
      return silentLogoutAndRedirect;
    }()
    /**
     * Refresh the access token by making a call to the /authorize in an AJAX request.
     *  If the user is logged in, we set the new access token and return true.
     * More details into how this works: https://www.notion.so/landr/Silent-authentication-with-FusionAuth-63b7fec05687437ea6460b2b25d1752a
     */
  }, {
    key: "silentlyRefreshTokens",
    value: function () {
      var _silentlyRefreshTokens = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var transaction, url, response, data;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(this.accessToken && this.accessTokenExpiration && this.accessTokenExpiration > Date.now() + ACCESS_TOKEN_EXPIRE_WINDOW)) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", Promise.resolve(true));
            case 2:
              _context8.prev = 2;
              this.log.info('Silently refreshing tokens', EventIds.AuthEventIds.SilentlyRefreshTokensInvoked);
              transaction = this.transactionManager.create({
                redirectUri: this.silentAuthRedirectUri,
                shouldStore: false
              });
              _context8.next = 7;
              return this.getAuthorizeUrl({
                redirectUri: this.silentAuthRedirectUri,
                transactionToUse: transaction
              });
            case 7:
              url = _context8.sent;
              _context8.next = 10;
              return fetch(url, {
                method: 'GET',
                mode: 'cors',
                redirect: 'follow',
                cache: 'no-cache',
                credentials: 'include'
              });
            case 10:
              response = _context8.sent;
              if (!(response.status === 201)) {
                _context8.next = 27;
                break;
              }
              _context8.prev = 12;
              _context8.next = 15;
              return response.json();
            case 15:
              data = _context8.sent;
              if (!(data.state && data.code)) {
                _context8.next = 22;
                break;
              }
              _context8.next = 19;
              return this.validateCodeAndState({
                state: data.state,
                code: data.code,
                transactionToUse: transaction
              });
            case 19:
              if (!this.accessToken) {
                _context8.next = 22;
                break;
              }
              this.log.info('Refreshed token successfully', EventIds.AuthEventIds.TokenRefreshedWithSuccess);
              return _context8.abrupt("return", true);
            case 22:
              _context8.next = 27;
              break;
            case 24:
              _context8.prev = 24;
              _context8.t0 = _context8["catch"](12);
              this.log.error('Error while silently validating code and state', EventIds.AuthEventIds.SilentValidateError, _context8.t0);
            case 27:
              _context8.next = 32;
              break;
            case 29:
              _context8.prev = 29;
              _context8.t1 = _context8["catch"](2);
              this.log.error('Error while silently checking login', EventIds.AuthEventIds.SilentLoginError, _context8.t1);
            case 32:
              return _context8.abrupt("return", false);
            case 33:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[2, 29], [12, 24]]);
      }));
      function silentlyRefreshTokens() {
        return _silentlyRefreshTokens.apply(this, arguments);
      }
      return silentlyRefreshTokens;
    }()
  }]);
  return FusionAuthSPAAuthProvider;
}(AbstractAuthProvider.AbstractAuthProvider);

exports.FusionAuthSPAAuthProvider = FusionAuthSPAAuthProvider;
